import 'Src/basic/style.scss'
import 'Src/basic/boot/user'
import 'Src/basic/global-mixins/index'
import 'Src/basic/boot/ajax'
import 'Src/basic/boot/i18n'
import 'Src/basic/boot/event'
import 'Src/basic/boot/getDeviceId'
import 'Src/basic/boot/log2'
import 'Src/basic/boot/log-tea'
import 'Src/basic/boot/pop-state-register'
import 'Src/basic/boot/suffix'
import 'Src/basic/boot/buried'
import 'Src/basic/boot/shortcut'
import 'Src/basic/boot/utils'
import 'Src/basic/boot/tti-state'
import { initImbot } from 'Src/basic/boot/imbot/imbot-sdk'

if (Number.parseInt === undefined) Number.parseInt = window.parseInt
if (Number.parseFloat === undefined) Number.parseFloat = window.parseFloat

const onTTIHandler = e => {
  if (e?.detail?.isTTI) {
    setTimeout(initImbot, 0)
    window.removeEventListener('ttistagechange', onTTIHandler, true)
  }
}

window.addEventListener('ttistagechange', onTTIHandler, true)
